@if (!crossEditing) {
  <zef-form-field>
    <mat-form-field color="accent">
      <mat-label>{{ translations.firstName }}</mat-label>
      <input
        matInput
        type="text"
        [ngrxEnableFocusTracking]="true"
        [ngrxFormControlState]="firstName"
        [readonly]="readOnly"
      />
    </mat-form-field>
  </zef-form-field>

  <zef-form-field>
    <mat-form-field color="accent">
      <mat-label>{{ translations.lastName }}</mat-label>
      <input
        matInput
        type="text"
        [ngrxEnableFocusTracking]="true"
        [ngrxFormControlState]="lastName"
        [readonly]="readOnly"
      />
    </mat-form-field>
  </zef-form-field>
}

<!--
<zef-form-field *ngIf="mode === 'edit'">
  <mat-form-field color="accent">

    <mat-label>{{ translations.email }}</mat-label>

    <input
      matInput
      type="email"
      name="email"
      [ngrxEnableFocusTracking]="true"
      [ngrxFormControlState]="email"
    />

    <mat-hint class="__hint">
      Contact support to change login email.
    </mat-hint>

  </mat-form-field>
</zef-form-field> -->
